import { Controller } from "@hotwired/stimulus";

// Handles both inline replacement (edit form) and detail toggling
export default class extends Controller {
  static targets = ["replace"];

  connect() {
    this.showingDetails = false;
  }

  async replace(event) {
    event.preventDefault();

    const url = event.currentTarget.href;

    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      const data = await response.json();

      this.replaceTarget.innerHTML = data.html;
    } catch (error) {
      console.error("Error loading piece-replacement form:", error);
    }
  }

  async toggleDetails(event) {
    event.preventDefault();

    // If details aren't shown, display them
    if (!this.showingDetails) {
      return this.showDetails(event);
    }

    // Otherwise, restore the original summary (Segment partial)
    try {
      // Change link text back to "Details..."
      event.currentTarget.textContent = "Details...";

      const response = await fetch(this.restoreUrl, {
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      const data = await response.json();

      this.replaceTarget.innerHTML = data.html;
      this.showingDetails = false;

    } catch (error) {
      console.error("Error restoring original segment:", error);
    }
  }

  // --- Helper: load the full Recording details partial ---
  async showDetails(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const url = new URL(event.currentTarget.href, window.location.origin);
    const segmentId = event.currentTarget.dataset.segmentId;
    const restoreUrl = event.currentTarget.dataset.restoreUrl;

    url.searchParams.append("segment[referrer]", segmentId);

    try {
      const response = await fetch(url.toString(), {
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      const data = await response.json();

      this.replaceTarget.innerHTML = data.html;
      this.showingDetails = true;
      this.restoreUrl = restoreUrl;

      // Optionally: change link text while open
      if (document.body.contains(link)) {
        link.textContent = "Hide Details";
      }

    } catch (error) {
      console.error("Error loading recording details:", error);
    }
  }

  updateDuration(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const recordingId = form.action.match(/recordings\/(\d+)/)[1];
    const submitButton = form.querySelector(`#submit-new-duration-${recordingId}`);
    if (submitButton) {
      submitButton.disabled = true; // optional visual feedback
    }
    const minutesInput = form.querySelector("#new-minutes-value");
    const secondsInput = form.querySelector("#new-seconds-value");

    if (!minutesInput || !secondsInput) {
      console.error("Minutes or seconds input not found");
      return;
    }

    const minutes = parseInt(minutesInput.value, 10) || 0;
    const seconds = parseInt(secondsInput.value, 10) || 0;

    const csrfTag = document.querySelector('meta[name="csrf-token"]');
    const token = csrfTag ? csrfTag.content : "";

    if (!token) {
      console.warn("CSRF token not found. Form submission might fail.");
    }

    fetch(form.action, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        recording: {
          minutes: minutes,
          seconds: seconds
        }
      })
    })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then(data => {
        minutesInput.textContent = data.minutes;
        secondsInput.textContent = data.seconds;
      })
      .catch(error => {
        console.error("Error updating duration:", error);
      })
      .finally(() => {
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  }

}
